import { render, staticRenderFns } from "./rtmpPushBackup.vue?vue&type=template&id=2951b724&scoped=true"
import script from "./rtmpPushBackup.vue?vue&type=script&lang=js"
export * from "./rtmpPushBackup.vue?vue&type=script&lang=js"
import style0 from "./rtmpPushBackup.vue?vue&type=style&index=0&id=2951b724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951b724",
  null
  
)

export default component.exports